import { useState } from "react";
import { updateUserModules } from "../../api/userService";

export const useUpdateUserModules = (successCallback) => {
  const [updating, setUpdating] = useState(false);
  const update = async (data) => {
    setUpdating(true);
    try {
      const newRecord = await updateUserModules(data);
      setUpdating(false);
      if (successCallback)
      {
        successCallback(newRecord);
      }
        return newRecord;
    } catch (error) {
      setUpdating(false);
      console.error("Failed to update user modules:", error);
      throw error; // rethrow so the component can handle errors
    }
  };

  return { update, updating };
};